import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import EditIcon from "@mui/icons-material/Edit";
import { red, yellow, green } from "@mui/material/colors";
import { TableWrapper } from "../styles";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';

const UsersTable = ({ ...props }) => {
  return (
    <TableContainer component={Paper}>
      <TableWrapper>
        <Table sx={{ minWidth: 650 }} aria-label="Users table">
          <TableHead
            style={{ position: "sticky", top: "0", backgroundColor: "#001753" }}
          >
            <TableRow>
              <TableCell
                align="right"
                style={{ color: "white", width: "90px" }}
              >
                Id
              </TableCell>
              <TableCell align="right" style={{ color: "white" }}>
                Name
              </TableCell>
              <TableCell align="right" style={{ color: "white" }}>
                Last name
              </TableCell>
              <TableCell align="center" style={{ color: "white" }}>
                E-mail
              </TableCell>
              <TableCell align="center" style={{ color: "white" }}>
                Phone
              </TableCell>
              <TableCell
                align="center"
                style={{ color: "white", width: "100px" }}
              >
                {props.approveUsers ? "Approve" : "Edit"}
              </TableCell>
              <TableCell
                align="center"
                style={{ color: "white", width: "100px" }}
              >
                {props.approveUsers ? "Denied" : "Discount"}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.items.length > 0 ? (
              props.items.map((row) => (
                <React.Fragment key={row.name + row.id}>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="right">{row.id}</TableCell>
                    <TableCell align="right">{row.name}</TableCell>
                    <TableCell align="right">{row.surname}</TableCell>
                    <TableCell align="right">{row.username}</TableCell>
                    <TableCell align="right">{row.phone}</TableCell>
                    <TableCell align="center">
                      {row.name === "No data" ? (
                        "No data"
                      ) : props.approveUsers ? (
                        <CheckCircleOutlineIcon
                          sx={{ color: green[700] }}
                          style={{ cursor: "pointer" }}
                          onClick={() => props.approveUser(row.id, "APPROVED")}
                        />
                      ) : (
                        <EditIcon
                          sx={{ color: yellow[700] }}
                          style={{ cursor: "pointer" }}
                          onClick={() => props.openEditUser(row.id)}
                        />
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {row.name === "No data" ? (
                        "No data"
                      ) : props.approveUsers ? (
                        <DoDisturbIcon
                          sx={{ color: red[800] }}
                          style={{ cursor: "pointer" }}
                          onClick={() => props.approveUser(row.id, "DECLINE")}
                        />
                      ) : (
                        <AppRegistrationIcon
                          sx={{ color: red[800] }}
                          style={{ cursor: "pointer" }}
                          onClick={() => props.openDiscount(row.id)}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            ) : (
              <TableRow key={"no_items"} className="product-from-group">
                <TableCell align="right">No items</TableCell>
                <TableCell align="right">No items</TableCell>
                <TableCell align="right">No items</TableCell>
                <TableCell align="center">No items</TableCell>
                <TableCell align="center">No items</TableCell>
                <TableCell align="center">No items</TableCell>
                <TableCell align="center">No items</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableWrapper>
    </TableContainer>
  );
};

export default UsersTable;
